import {NavigationEvent} from '@spartacus/storefront/events/navigation/navigation.event';
import {CxEvent} from '@spartacus/core';

export class ErrorPageEvent extends CxEvent {
  static readonly type = 'ErrorPageEvent';

  navigation: NavigationEvent;
  errorType?: string;
  pageSection?: string;
  description?: string;
}
